/* eslint-disable import/no-unresolved */

import React from 'react';

import shortid from 'shortid';

import { getSlugName } from '../../helpers/util';
import useCaseStudies from '../../graphql/staticQueries/useCaseStudies';

import ServicesHeading from '../../components/SoftwareServices/ServicesHeading';
import Layout from '../../components/Layout';
import PartialsHeader from '../../components/Partials/PartialsHeader';
import OptimizedImage from '../../components/OptimizedImage';
import MultiCarousel from '../../components/Carousels/MultipleCarousel';
import ResultTestimonial from '../../components/Result/ResultTestimonial';
import ResultsCardSwiperSection from '../../components/ResultsCardSwiperSection';
import LandingPageInfoBox from '../../components/LandingPages/LandingPageInfoBox';
import HomeKnowledge from '../../components/Home/HomeKnowledge';
import Banner from '../../components/service/Products/productsPartials/DevOpsBanner';
import CultureItem from '../../components/AboutUs/aboutUsPartials/CultureItem';
import SingleBox from '../../components/Careers/careersPartials/SingleBox';
import imagesPillarPages from '../../components/imagesPillarPages';
import imagesLandingPages from '../../components/imagesLandingPages';
import CheckmarkColumns from '../../components/SoftwareServices/CheckmarkColumns';
import TelecommunicationSection from '../../components/SoftwareServices/TelecommunicationSection';

import content from '../../components/SoftwareServices/content-cryptocurrency-trading-platforms';

const SoftwareServices = () => {
  const cases = useCaseStudies();
  const selectedCase = cases.find(caseStudy => {
    const slug = getSlugName(caseStudy);
    return slug === 'cryptocurrency-lending-platform';
  });

  const responsive = [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 460,
      settings: {
        slidesToShow: 2
      }
    }
  ];

  return (
    <Layout
      title="Cryptocurrency and trading platforms | Ulam Labs"
      description="Build powerful cryptocurrency services, crypto wallets, smart contracts and other blockchain solutions designed for FinTech companies."
    >
      <PartialsHeader>
        <div className="container">
          <div className="content">
            <div className="body">
              <h1 className="title">Cryptocurrency &#38; Trading Platforms</h1>
            </div>
          </div>
        </div>
      </PartialsHeader>
      <ServicesHeading headingText={content.headingText} />
      <div className="container">
        <div className="mt-5">
          <h2 className="subtitle bigger">
            Spearhead DeFi movement with our cryptocurrency development services
          </h2>
          <div className="content">
            <p>
              Embrace disruptive technology to change finance with your
              business. Use decentralized finance and digital assets to reinvent
              your industry.
            </p>
          </div>
        </div>
        <div className="company-presentation landing pt-3 pb-0">
          <div className="icon-items">
            <div className="row">
              <CultureItem
                mainText="Create breakthrough crypto trading platform"
                secText="Build your own cryptocurrency exchange well-tailored to your needs with
                BTC, ETH, BCH, XRP, EOS support. Top choice for all fintech enthusiasts aiming to build
                customized cryptocurrency exchange software with secure and fast transactions."
                img={imagesPillarPages.graphSVG}
              />
              <CultureItem
                mainText="Secure your customers funds"
                secText="Store your customer funds using safe hot and cold wallet solutions compatible with
                CryptoCurrency Security Standard (CCSS). We assure secure and robust wallet development while
                utilizing the best features and innovative development methodologies."
                img={imagesPillarPages.walletSVG}
              />
              <CultureItem
                mainText="Build apps that embrace digital assets"
                secText="Forget the old world of finance, a new era of blockchain-enabled innovation with digital
                assets is rising. Cryptocurrency and secure digital payments are the future for many fintech 
                industries. Be prepared for this change by choosing a technology leader."
                img={imagesPillarPages.phoneSVG}
              />
            </div>
            <div className="row">
              <CultureItem
                mainText="Connect crypto and fiat worlds"
                secText="Buy, keep and exchange crypto as easily as you send text messages! Create cryptocurrency
                services that make the digital transitions seamless. Our blockchain developers create platforms 
                that process all your transactions with ease and through the highest security checks."
                img={imagesPillarPages.cloadSVG}
              />
              <CultureItem
                mainText="Disrupt banking system"
                secText="Stablecoins, decentralized lending and borrowing are going to disrupt the old banking world. 
                With our team of cryptocurrency developers on board, you can be sure you are the new leader."
                img={imagesPillarPages.bankSVG}
              />
              <CultureItem
                mainText="Help 3rd world countries reach their potential"
                secText="Cryptocurrencies have the potential to enable social and economic growth throughout the world
                by offering stable and robust decentralized banking systems."
                img={imagesPillarPages.globusSVG}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="simple-service landing expended main-view text-format">
        <div className="container">
          <div className="main-beam">
            <Banner
              customTitle="Our approach to software development"
              customSubtitle="Find out how we develop services for our FinTech clients"
            />
          </div>
        </div>
      </div>
      <div className="result-show version-pillar">
        <ResultTestimonial
          content={content.testimonialText}
          caseStudy={selectedCase}
          versionPillar
        />
      </div>
      <div className="my-5 crypto-result-card">
        <div className="container">
          <div className="row">
            <div className="col">
              <h2 className="subtitle without bigger mb-3 pb-0">
                Cryptocurrency and trading platform projects we’ve delivered
              </h2>
            </div>
          </div>
        </div>
        <ResultsCardSwiperSection
          title="See related projects"
          buttonsAround={false}
          className="basis-slider"
          useSpecificCases={['cryptocurrency-lending-platform']}
          onlySlider
        />
      </div>
      <div className="container-fluid" style={{ background: '#eaebf1' }}>
        <div className="container py-5">
          <div className="subtitle without bigger">
            Blockchain platforms we expertise
            <div className="extra" style={{ maxWidth: '46rem' }}>
              As a professional cryptocurrency software development company, we
              already have predefined integrations with many public blockchains.
            </div>
          </div>
          <div className="key-results" style={{ border: 'none' }}>
            <div className="item version-pillar swiper">
              <MultiCarousel slidesToShow={4} responsive={responsive}>
                {content.carouselImages.map(img => {
                  return (
                    <div key={shortid.generate()}>
                      <OptimizedImage
                        src={img.src}
                        className="img-fluid"
                        style={{ width: '8rem', height: '6rem' }}
                        alt={img.alt}
                        title={img.title}
                      />
                    </div>
                  );
                })}
              </MultiCarousel>
            </div>
          </div>
        </div>
      </div>
      <div className="container container-line py-5">
        <div className="section-points">
          <div className="row">
            <div className="col">
              <h2 className="subtitle bigger">
                Build your competitive advantage with our crypto services
              </h2>
              <div className="content">
                <p>
                  Choose from a complete range of crypto services starting from
                  cryptocurrency development to maintenance service, we cover it
                  all.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="icon-beam pt-2">
              <div className="row">
                <CheckmarkColumns
                  checkmarkColumnsData={content.checkmarkColumnsData}
                  threePerRow
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container horizontal-line">
        <div className="row flex-column">
          <div className="container about-us">
            <div className="key-results" style={{ border: 'none' }}>
              <div className="item head">
                <div className="element">
                  <h3 className="mb-0">
                    We integrate with supplementary cryptocurrency services
                  </h3>
                </div>
              </div>
              <div className="item version-pillar swiper">
                <MultiCarousel slidesToShow={2} responsive={responsive}>
                  {content.carouselImages2.map(img => {
                    return (
                      <div key={shortid.generate()}>
                        <OptimizedImage
                          src={img.src}
                          className="img-fluid"
                          style={{ width: '10rem' }}
                          alt={img.alt}
                          title={img.title}
                        />
                      </div>
                    );
                  })}
                </MultiCarousel>
              </div>
            </div>
          </div>
        </div>
      </div>
      <TelecommunicationSection
        telecomSectionData={content.telecomSectionData1}
      />
      <div className="container my-5">
        <div className="subtitle bigger without">
          Why work with our blockchain developers?
        </div>
        <div className="work-with d-flex flex-column flex-md-row justify-content-between">
          <LandingPageInfoBox
            icon={imagesLandingPages.pythonSVG}
            title="Python blockchain developers"
            description="Ulam Labs has been developing services in Python programming language and blockchain technology - a perfect combination for any project."
          />
          <LandingPageInfoBox
            icon={imagesPillarPages.consultingSVG}
            title="Experienced engineers"
            description="Work daily with skilled and experienced blockchain developers."
          />
          <LandingPageInfoBox
            icon={imagesLandingPages.teamextensionSVG}
            title="Flexible collaboration"
            description="Get a dedicated team of blockchain developers full-time, part-time, or hourly. Scale up your team according to your needs."
          />
        </div>
        <div className="work-with d-flex flex-column flex-md-row justify-content-between">
          <LandingPageInfoBox
            icon={imagesLandingPages.outcomeSVG}
            title="Excellent communication"
            description="Communication is as important for Ulam Labs as technical knowledge. You can be sure that we put effective and timely communication as one of our priorities."
          />
          <LandingPageInfoBox
            icon={imagesLandingPages.icon4SVG}
            title="Complementary services"
            description="In addition to blockchain development services, we have everything you need for a long-term, end-to-end tech partnership."
          />
          <LandingPageInfoBox
            icon={imagesLandingPages.ourroleSVG}
            title="Client's trust"
            description="More than 90% of our customers come back with their new projects and recommend our services."
          />
        </div>
      </div>
      <div className="padd-b-sm knowledge-services">
        <HomeKnowledge
          useSpecificPostsByTag={['Cryptocurrency']}
          customTitle="Read more about cryptocurrency software development on our blog"
          customSubtitle="Our team of developers
        takes an active part in creating educational and valuable content for our clients who
        are thinking about software development for FinTech. Read our blog to understand the
        blockchain technology better and know how to use it to solve a variety of real-world problems."
          versionPillar
        />
      </div>
      <div className="container my-4 my-md-0 services-banner-top">
        <Banner
          customTitle="Planning to build cryptocurrency platform?"
          version="servicesPage"
        />
      </div>
      <div className="version-pillar pb-5 padd-t container">
        <div className="info-box">
          <div>
            <h3 className="subtitle without bigger">
              What other services do we offer?
            </h3>
            <div className="row">
              <SingleBox
                image={imagesPillarPages.chainSVG}
                heading="Blockchain development"
                url="/software-services/blockchain-development/"
              />
              <SingleBox
                image={imagesLandingPages.pythonSVG}
                heading="Python development"
                url="/software-services/python-development/"
              />
              <SingleBox
                image={imagesPillarPages.logoJS}
                heading="JavaScript development"
                url="/software-services/javascript-development/"
              />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SoftwareServices;
